import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  openMenu(){
    document.querySelector('body').classList.add('blur-in');
    document.querySelector('#h-nav').classList.add('show-in');
    console.log('Menu opened');
  }
  closeMenu(){
    document.querySelector('body').classList.remove('blur-in');
    document.querySelector('#h-nav').classList.remove('show-in');
    console.log('Menu closed');
  }

}
